import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import ActiveFieldset from '@/components/atoms/Fieldset/templates/IntegrationsFieldset/ActiveFieldset';
import DeleteFieldset from '@/components/atoms/Fieldset/templates/IntegrationsFieldset/DeleteFieldset';
import SessionTimeoutFieldset from '@/components/atoms/Fieldset/templates/IntegrationsFieldset/SessionTimeoutFieldset';
import { useAccordion } from '@/hooks/useAccordion';
import { getPermissions } from '@/redux/permissions/selectors';
import { SmartleadIntegration } from '@/shared/types/integration';
import { actions } from '@/shared/types/permissions';
import { RootState } from '@/shared/types/state';

import SmartleadFieldset from './SmartleadFieldset';

const IntegrationSmartlead = () => {
  const { t } = useTranslation();
  const canWrite = useSelector((state: RootState) =>
    getPermissions(state, 'integrations', actions.WRITE)
  );
  const { integration } = useAccordion<SmartleadIntegration>(canWrite);

  return (
    <div className="flex flex-col gap-4">
      <SmartleadFieldset integration={integration} />
      <SessionTimeoutFieldset integration={integration} />
      {integration?.integration_id && integration?.config?.apikey && (
        <ActiveFieldset
          integration={integration}
          title={t('integrations.status.title')}
          subtitle={t('integrations.status.subtitle')}
        />
      )}

      <DeleteFieldset integration={integration} disabled={!canWrite} />
    </div>
  );
};

export default IntegrationSmartlead;
